import React, { useEffect, useState, useRef } from "react";
import "./Scheduledemo.css";
import { isValidEmail, isValidPhoneNumber } from "../Constants";
import {
  INTERNAL_RECIPIENTS,
  buildDemoInternalContent,
  buildDemoUserContent,
  buildPayload,
  sendMail,
  sendMailToList,
} from "../../services/mailService";
import { Urls } from "../../Urls";
import Loader from "../Loader";
import classes from "../Scheduledemo/Scheduledemo.module.css";
import ReactGA from "react-ga";
import mixpanel from "mixpanel-browser";
import {
  TextField,
  FormControlLabel,
  Checkbox,
  Button,
  Grid,
  MenuItem,
} from "@material-ui/core";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CalendlyPopupButton from "./CalendlyPopupButton";
import { CALENDLY_URL } from "../../config";

const Scheduledemo = ({ setIsSuperUser }) => {
  const [show, setShow] = useState(false);
  const [calendlyOpen, setCalendlyOpen] = useState(false);
  const [calendlyPrefill, setCalendlyPrefill] = useState({});

  const heardFromOptions = [
    "Google Search",
    "Social Media",
    "Referral from an Existing Customer",
    "Industry Event",
    "Other",
  ];

  const [userInput, setUserInput] = useState({
    name: "",
    company_name: "",
    email: "",
    contact_number: "",
    designation: "",
    check: true,
    heardFrom: "",
  });

  const handleChange = (key, value) => {
    setUserInput((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const restrictedDomains = [
    "gmail.com",
    "yahoo.com",
    "yahoo.co.in",
    "hotmail.com",
    "outlook.com",
    "rediffmail.com",
    "live.com",
    "msn.com",
    "aol.com",
    "icloud.com",
  ];

  const handleScheduleDemo = (e) => {
    e?.preventDefault();

    if (!userInput.email || !isValidEmail(userInput.email)) {
      toast.error("Please Enter Valid Email Address");
      return;
    }

    const emailDomain = userInput.email.split("@")[1]?.toLowerCase();
    if (emailDomain && restrictedDomains.includes(emailDomain)) {
      toast.error("Please enter a company email address");
      return;
    }

    if (userInput.contact_number && !isValidPhoneNumber(userInput.contact_number)) {
      toast.error("Please Enter Valid Phone Number");
      return;
    }

    ReactGA.event({
      category: "Schedule Demo",
      action: "Schedule Demo Form Submitted Successfully",
    });

    mixpanel.track(`User has requested a demo`, {
      ApplicationName: `${Urls.mixpanelappname}`,
      ScreenName: "home",
      ModuleName: "landing_page",
      ActivityLog: `userClickedRequestDemoButton`,
      Name: userInput.name,
      CompanyName: userInput.company_name,
      Email: userInput.email,
      ContactNumber: userInput.contact_number,
      Designation: userInput.designation,
      HeardFrom: userInput.heardFrom,
      Newsletter: userInput.check ? "Yes" : "No",
      Definition: `User has requested a demo`,
      ActivityType: "event_view",
    });

    setCalendlyPrefill({ name: userInput.name || "", email: userInput.email || "" });
    setCalendlyOpen(true);
    sessionStorage.setItem("isEmailExist", "yes");
    setIsSuperUser(true);
    toast.success("Demo Request Sent Successfully");

    const internalSubject = [
      "Demo Request for LoRRI",
      userInput.name && `| ${userInput.name}`,
      userInput.company_name && `| ${userInput.company_name}`,
    ]
      .filter(Boolean)
      .join(" ");

    setShow(true);
    Promise.all([
      sendMailToList(INTERNAL_RECIPIENTS, {
        subject: internalSubject,
        content: buildDemoInternalContent(userInput),
      }),
      sendMail(
        buildPayload({
          to: userInput.email,
          subject: "Your LoRRI Demo is Confirmed",
          content: buildDemoUserContent(userInput),
        })
      ),
    ])
      .then(() => {
        setShow(false);
        setUserInput({
          name: "",
          company_name: "",
          email: "",
          contact_number: "",
          designation: "",
          check: false,
          heardFrom: "",
        });
      })
      .catch((err) => {
        setShow(false);
        console.log(err);
      });
  };

  // track how many users land on / view the schedule demo form
  useEffect(() => {
    ReactGA.event({
      category: "Schedule Demo",
      action: "Schedule Demo Form Viewed",
    });
  }, []);

  // the code below is prevents materialize css to overwrite mui styles - DO NOT REMOVE
  const scheduleFormRef = useRef(null);

  useEffect(() => {
    if (scheduleFormRef.current) {
      const inputElements = scheduleFormRef.current.querySelectorAll("input");

      if (inputElements && inputElements.length > 0) {
        inputElements.forEach((input) => {
          input.classList.add("browser-default");
        });
      }
    }
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const fields = ["name", "email", "company_name", "contact_number", "designation", "heardFrom"];
    const updates = {};
    fields.forEach((field) => {
      const val = params.get(field);
      if (val) updates[field] = val;
    });
    if (Object.keys(updates).length > 0) {
      setUserInput((prev) => ({ ...prev, ...updates }));
    }
  }, []);

  return (
    <div
      className={`row ${classes["schedule-form"]}`}
      id="schedule-form"
      ref={scheduleFormRef}
    >
      <Loader show={show} />
      <div className={classes["responsive-text"]}>
        SCHEDULE MEETING / DEMO NOW
      </div>
      <form
        className={classes["s-requestdemo-form"]}
        onSubmit={handleScheduleDemo}
        style={{ marginTop: "30px" }}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <TextField
              className={"browser-default"}
              placeholder="Name"
              value={userInput.name}
              onChange={(e) => handleChange("name", e.target.value)}
              id="Demo_First_Name"
              label="Name"
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              className={"browser-default"}
              placeholder="Email"
              value={userInput.email}
              onChange={(e) => handleChange("email", e.target.value)}
              id="Demo_Email"
              label="Organization Email *"
              type="email"
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              className={"browser-default"}
              placeholder="Company Name"
              value={userInput.company_name}
              onChange={(e) => handleChange("company_name", e.target.value)}
              id="Demo_Company_Name"
              label="Company Name"
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              className={"browser-default"}
              placeholder="Designation"
              value={userInput.designation}
              onChange={(e) => handleChange("designation", e.target.value)}
              id="Demo_Designation"
              label="Designation"
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              className={"browser-default"}
              placeholder="Contact Number"
              value={userInput.contact_number}
              maxLength="10"
              onChange={(e) => handleChange("contact_number", e.target.value)}
              id="Demo_Contact_Number"
              label="Contact Number"
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              select
              label="How did you hear about us?"
              value={userInput.heardFrom}
              onChange={(e) => handleChange("heardFrom", e.target.value)}
              variant="outlined"
              fullWidth
              menuprops={{
                getContentAnchorEl: null,
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
              }}
              InputProps={{
                classes: {
                  root: classes.outlinedInput,
                },
              }}
            >
              {heardFromOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={userInput.check}
                  style={{ color: "#393185" }}
                  onChange={(e) => handleChange("check", e.target.checked)}
                />
              }
              label="I would like to receive updates on latest modules and news from LoRRI."
            />
          </Grid>
          <Grid
            item
            xs={12}
            style={{ marginBottom: "12px", marginTop: "8px" }}
          >
            <Button
              type="submit"
              variant="contained"
              color="primary"
              size="large"
              fullWidth
              onClick={() =>
                ReactGA.event({
                  category: "Schedule Demo",
                  action: "Schedule Demo Button Clicked",
                })
              }
            >
              Schedule Demo
            </Button>
          </Grid>
        </Grid>
      </form>
      <CalendlyPopupButton
        url={CALENDLY_URL}
        triggerPopup={false}
        open={calendlyOpen}
        moduleName="ScheduleDemo"
        prefill={calendlyPrefill}
        onClose={() => setCalendlyOpen(false)}
        userData={{
          Name: userInput.name,
          CompanyName: userInput.company_name,
          Email: userInput.email,
          ContactNumber: userInput.contact_number,
          Designation: userInput.designation,
          HeardFrom: userInput.heardFrom,
          Newsletter: userInput.check ? "Yes" : "No",
        }}
      />
    </div>
  );
};

export default Scheduledemo;
